
/*
 * ! @chakra-ui/vue v0.13.1 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { D as extractListeners } from './index-2216d089.js';
import './chakra-ui-styled-system.esm-a8a2e91f.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-de5da461.js';
import './anime.es-fe1e1e1f.js';
import CBox from './CBox.js';
import { CAnimateHeight } from './CTransition.js';

/**
 * Hey! Welcome to @chakra-ui/vue Collapse
 *
 * The Collapse component is used to create regions of content
 * that can expand/collapse with a simple animation. It helps to hide
 * content that's not immediately relevant to the user.
 *
 * @see Docs     https://vue.chakra-ui.com/collapse
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CCollapse/CCollapse.js
 */
function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}
/**
 * CCollapse component
 *
 * Create regions of content that can expand/collapse
 * with a simple animation.
 *
 * @extends CAnimateHeight
 * @see Docs https://vue.chakra-ui.com/collpse
 */

var CCollapse = {
  name: 'CCollapse',
  functional: true,
  props: {
    isOpen: Boolean,
    duration: {
      type: Number,
      default: 250
    },
    easing: {
      type: String,
      default: 'easeInOutSine'
    },
    startingHeight: Number,
    endingHeight: Number,
    animateOpacity: {
      type: Boolean,
      default: true
    }
  },
  render: function render(h, ref) {
    var slots = ref.slots;
    var props = ref.props;
    var data = ref.data;
    var listeners = ref.listeners;
    var rest$1 = objectWithoutProperties(ref, ["slots", "props", "data", "listeners"]);
    var rest = rest$1; // Get children

    var children = slots().default; // Handle events

    var nonNativeEvents = {
      start: function start(e) {
        var emitStart = listeners.start;

        if (emitStart) {
          emitStart('start', e);
        }
      },
      finish: function finish(e) {
        var emitFinish = listeners.finish;

        if (emitFinish) {
          emitFinish('finish', e);
        }
      }
    };
    var ref$1 = extractListeners({
      listeners: listeners
    }, nonNativeEvents);
    var native = ref$1.native;
    var nonNative = ref$1.nonNative;
    return h(CAnimateHeight, Object.assign({}, rest, {
      props: {
        isOpen: props.isOpen,
        duration: props.duration,
        enterEasing: props.easing,
        leaveEasing: props.easing,
        initialHeight: props.startingHeight,
        finalHeight: props.endingHeight,
        animateOpacity: props.animateOpacity
      },
      on: nonNative,
      nativeOn: native,
      attrs: {
        'data-chakra-component': 'CCollapse'
      }
    }), [h(CBox, {
      props: {
        as: props.as
      },
      attrs: data.attrs
    }, children)]);
  }
};

export default CCollapse;
